import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/all', label: '分类' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-book-open-line text-2xl" style={{ color: 'oklch(var(--primary-500))' }}></i>
            </div>
            <span className="font-heading text-xl font-bold text-foreground-900">
              韩漫网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.to
                    ? 'text-primary-500'
                    : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-48 px-4 py-2 text-sm rounded-full bg-background-100 border border-background-200/70 text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100/50 transition-all"
              />
              <div className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
                <i className="ri-search-line text-sm text-foreground-400"></i>
              </div>
            </div>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl text-foreground-900 ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium py-2 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.to
                    ? 'text-primary-500'
                    : 'text-foreground-700'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="relative mt-2">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-full px-4 py-2.5 text-sm rounded-full bg-background-100 border border-background-200/70 text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-300"
              />
              <div className="absolute right-4 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
                <i className="ri-search-line text-sm text-foreground-400"></i>
              </div>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}